import { SmartQuestionStatus } from '@/gen/inventory/v1/control_service_pb'

import type { ControlRow } from '@/pages/control/ag-grid-control/types'

// Include a status for "No response" so that we can put it after AWAITING_REOPEN
type ComparableStatus = SmartQuestionStatus | 'No response'

// Default ordering for the Smart evidence request column: controls that need
// attention (responses ready to review) first, empty/no-request last. A status'
// rank is its index in this array.
const SMART_QUESTION_STATUS_SORT_ORDER: ComparableStatus[] = [
  SmartQuestionStatus.AWAITING_REVIEW,
  SmartQuestionStatus.AWAITING_REOPEN,
  'No response',
  SmartQuestionStatus.AWAITING_RECIPIENT,
  SmartQuestionStatus.RESOLVED,
  SmartQuestionStatus.PUBLISHED,
  SmartQuestionStatus.UNPUBLISHED,
  SmartQuestionStatus.UNSPECIFIED,
]

export const smartQuestionStatusComparator = (
  _a: SmartQuestionStatus,
  _b: SmartQuestionStatus,
  nodeA: { data?: ControlRow },
  nodeB: { data?: ControlRow },
): number => {
  const sqA = nodeA.data?.smartQuestion
  const sqB = nodeB.data?.smartQuestion
  let statusA: ComparableStatus = sqA?.status ?? SmartQuestionStatus.UNSPECIFIED
  let statusB: ComparableStatus = sqB?.status ?? SmartQuestionStatus.UNSPECIFIED

  // Custom "no response" for "Ready for review" status with not response.
  if (
    statusA === SmartQuestionStatus.AWAITING_REVIEW &&
    nodeA.data?.smartQuestion?.lastResponseType === undefined
  ) {
    statusA = 'No response'
  }

  if (
    statusB === SmartQuestionStatus.AWAITING_REVIEW &&
    nodeB.data?.smartQuestion?.lastResponseType === undefined
  ) {
    statusB = 'No response'
  }

  const rankA = SMART_QUESTION_STATUS_SORT_ORDER.indexOf(statusA)
  const rankB = SMART_QUESTION_STATUS_SORT_ORDER.indexOf(statusB)

  if (rankA !== rankB) return rankA - rankB

  // Within "Ready for review", newest last action first; missing timestamps last.
  if (statusA === SmartQuestionStatus.AWAITING_REVIEW) {
    const tA = sqA?.lastResponseAt ? Number(sqA.lastResponseAt.seconds) : -Infinity
    const tB = sqB?.lastResponseAt ? Number(sqB.lastResponseAt.seconds) : -Infinity
    return tB - tA
  }

  return 0
}
